import { FC } from 'react';

import { Divider } from '@bonusly/design-system';

export const UserNavDivider: FC & { isNavDivider: boolean } = () => <Divider borderColor="border.default" />;

UserNavDivider.isNavDivider = true;
